import { useUser } from "@features/user"
import useEnv from "./useEnv"

interface MenuItem {
  labelKey: string
  icon: string
  route: string
  external: boolean
  visible: boolean
}

const useLeftMenu = (): MenuItem[] => {
  const { data } = useUser()
  const { geconturUrl } = useEnv()

  if (!data) {
    return []
  }

  const { can } = data

  return [
    {
      labelKey: "home",
      icon: "fa fa-dashboard",
      route: geconturUrl || "", // Ensure route is a string
      external: true,
      visible: true,
    },
    {
      labelKey: "agencyVisits",
      icon: "fa fa-handshake-o",
      route: `${geconturUrl}/agency-visit`,
      external: true,
      visible: can.viewMenuAgencyVisits || can.viewMenuAgencyAllVisits,
    },
    {
      labelKey: "travelChecks",
      icon: "fa fa-money",
      route: `${geconturUrl}/travelers-check`,
      external: true,
      visible: can.viewMenuTravelerChecks,
    },
    {
      labelKey: "contacts",
      icon: "fa fa-address-book-o",
      route: `${geconturUrl}/contact`,
      external: true,
      visible: can.viewMenuContacts,
    },
    {
      labelKey: "documents",
      icon: "fa fa-files-o",
      route: `${geconturUrl}/message`,
      external: true,
      visible: can.viewMenuDocuments,
    },
    {
      labelKey: "messagePopup",
      icon: "fa fa-window-restore",
      route: `${geconturUrl}/message`,
      external: true,
      visible: can.manageMessages,
    },
    {
      labelKey: "inquiries",
      icon: "fa fa-bar-chart",
      route: `${geconturUrl}/inquiry`,
      external: true,
      visible: can.manageInquiries,
    },
    {
      labelKey: "offers",
      icon: "fa fa-cubes",
      route: "/offers",
      visible: can.viewMenuPdf,
      external: false, // You can assume internal navigation here, or adjust as needed
    },
    {
      labelKey: "newsletters",
      icon: "fa fa-envelope",
      route: "/newsletter",
      visible: can.viewMenuNewslettersNew,
      external: false,
    },
    {
      labelKey: "signature",
      icon: "fa fa-credit-card",
      route: "/signature",
      visible: can.viewMenuSignature,
      external: false,
    },
    {
      labelKey: "homeLayout",
      icon: "fa fa-columns",
      route: `${geconturUrl}supplier`,
      external: true,
      visible: can.viewMenuSuppliers,
    },
    {
      labelKey: "marketing",
      icon: "fa fa-picture-o",
      route: `${geconturUrl}newsletter-headers`,
      external: true,
      visible: can.viewMenuMarketing,
    },
    {
      labelKey: "intranet",
      icon: "fa fa-fa fa-browser",
      route: "https://intranet.newtour.pt/site/login",
      external: true,
      visible: can.menuIntranetNewtour,
    },
    {
      labelKey: "adminTools",
      icon: "fa fa-gears",
      route: `${geconturUrl}/users`,
      external: true,
      visible: can.viewMenuAdmin,
    },
  ]
    .filter(({ visible }) => visible)
    .map((item) => ({
      ...item,
      route: item.route || "",
    }))
}

export default useLeftMenu
